export default {
  "Autocomplete.all_number_selected": "Выбрано {number, plural, one {все} other {все {number}}}",
  "Autocomplete.all_number": "Все ({number})",
  "Card.toggle_content": "показать/спрятать содержимое",
  "Chip.remove": "удалить",
  "DatePicker.next": "Следующий",
  "DatePicker.previous": "Предыдущий",
  "Pagination.first": "первую",
  "Pagination.go_to_page_number": "Перейти на страницу {index}",
  "Pagination.go_to_page": "Перейти на {label} страницу",
  "Pagination.last": "последнюю",
  "Pagination.next": "следующую",
  "Pagination.previous": "предыдущую",
  "Table.actions": "Действия с таблицей",
  "Table.add_column": "Добавить столбец",
  "Table.filter": "Фильтр",
  "Table.hide": "Скрыть",
  "Table.more_actions": "Больше действий",
  "Table.move_left": "Передвинуть влево",
  "Table.move_right": "Передвинуть вправо",
  "Table.not_specified": "Не указано",
  "Table.pagination": "Пагинация таблицы",
  "Table.per_page": "На страницу",
  "Table.position_zero": "0 из {total}",
  "Table.position": "{start}-{end} из {total}",
  "Table.search": "Поиск",
  "Table.select_all": "Выбрать все",
  "Table.select_row": "Выбрать {row}",
  "Table.sort_ascending": "Сортировать по возрастанию",
  "Table.sort_descending": "Сортировать по убыванию",
  "TextInput.clear_labelled_input": "Очистить {label}",
  "Ui.clear_all": "Сбросить",
  "Ui.close": "Закрыть",
  "Ui.loading": "Загрузка",
  "Ui.no_results": "Pезультатов не найдено",
  "Ui.number_selected": "Выбрано {number}",
  "Ui.remove": "Удалить",
  "Ui.select_all": "Выбрать все",
  "Ui.show_more": "+ {count} еще"
}
